<template>
  <v-container class="bg-white">
    <v-card
      class="pa-5"
      variant="text">
      <v-card-item>
        <v-card-title>Zusammenfassung</v-card-title>
        <template #append>
          <v-fab
            elevation="0"
            icon="mdi-close"
            @click.prevent="$emit('close')"></v-fab>
        </template>
      </v-card-item>

      <v-card-text>
        <p>
          {{ $t("views.licence.review.monthlyCosts", { costs: monthlyCosts }) }}
        </p>
        <p v-if="yearlyCosts > 0">
          {{ $t("views.licence.review.yearlyCosts", { costs: yearlyCosts }) }}
        </p>
        <p v-if="additionalCosts > 0">
          {{
            $t("views.licence.review.additionalCosts", {
              additionalPrice: additionalCosts,
              remainingDays: remainingDays
            })
          }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="3"
          @click="emits('close')">
          Abbrechen
        </v-btn>
        <v-btn
          elevation="3"
          data-cy="licence-popup-save"
          @click="emits('save')"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script lang="ts" setup>
const emits = defineEmits(["close", "save"]);

const props = defineProps({
  monthlyCosts: {
    type: Number,
    required: true
  },
  yearlyCosts: {
    type: Number,
    required: true
  },
  remainingDays: {
    type: Number,
    required: true
  },
  additionalCosts: {
    type: Number,
    required: true
  }
});
</script>
